module.exports = lgPay;